import { render, staticRenderFns } from "./site-reminder-section.vue?vue&type=template&id=8bdfa12e&scoped=true&"
import script from "./site-reminder-section.vue?vue&type=script&lang=js&"
export * from "./site-reminder-section.vue?vue&type=script&lang=js&"
import style0 from "./site-reminder-section.vue?vue&type=style&index=0&id=8bdfa12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdfa12e",
  null
  
)

export default component.exports